<template>
  <div class="cont">
    <div class="title">
      <div class="title_name"></div>
    </div>

    <div class="clear" style="margin-bottom:37px">
      <router-link to="SilencerCream" append>
        <div class="img_cont img_cont_one clear" style="margin-right:37px">
          <div class="img_one img"></div>
          <div class="img_two img"></div>
          <div class="img_three img"></div>
          <div class="img_four img"></div>
        </div>
      </router-link>

      <router-link to="TempTestPaper" append>
        <div class="img_cont img_cont_two clear" >
          <div class="img_one img"></div>
          <div class="img_two img"></div>
          <div class="img_three img"></div>
          <div class="img_four img"></div>
        </div>
      </router-link>

      <router-link to="PeripheralGifts" append>
        <div class="img_cont img_cont_three clear" >
          <div class="img_one img"></div>
          <div class="img_two img"></div>
          <div class="img_three img"></div>
          <!-- <div class="img_four img"></div> -->
        </div>
      </router-link>

    </div>


  </div>
</template>

<script>
export default {
  name: "ContOne",
  data() {
    return {
      fit: "contain"
    };
  },
  methods: {}
};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  padding: 62px 73px;
  box-sizing: border-box;
  position relative
}

.clear:after {
  display: block;
  clear: both;
  content: '';
}

.title {
  position: absolute;
  width: 170px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/variousproducts/other/img21.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 23px 56px 24px 58px;
  box-sizing: border-box;
}

.title_name {
  width: 56px;
  height: 61px;
  background: url('~@/assets/image/variousproducts/other/img22.png');
  background-repeat: no-repeat;
  background-size: contain;
}


.img_cont {
  width: 410px;
  height: 103px;
  float: left;
  cursor pointer
}
  .img{
    background-repeat: no-repeat;
    background-size: cover;
    float: left;
  }
.img_cont_one
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/other/img1.png');
    margin-right:5px;
    background-repeat: no-repeat;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/other/img2.png');
    margin-right:6px;
    background-repeat: no-repeat;
  }
  .img_three{
    width: 135px;
    height: 23px;
    background: url('~@/assets/image/variousproducts/other/img3.png');
    margin-bottom:8px;
    background-size:contain;
    background-repeat: no-repeat;
  }
  .img_four{
    width: 240px;
    height: 34px;
    background: url('~@/assets/image/variousproducts/other/img4.png');
    background-size: contain;
    background-repeat: no-repeat;
  }
.img_cont_two
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/other/img5.png');
    margin-right:5px;
  background-repeat: no-repeat;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/other/img6.png');
    margin-right:6px;
    background-repeat: no-repeat;
  }
  .img_three{
    width: 113px;
    height: 23px;
    background: url('~@/assets/image/variousproducts/other/img7.png');
    margin-bottom:8px;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .img_four{
    width: 241px;
    height: 34px;
    background: url('~@/assets/image/variousproducts/other/img8.png');
    background-repeat: no-repeat;
  }
.img_cont_three
  margin-top: 40px
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/other/img9.png');
    margin-right:5px;
                  background-repeat: no-repeat;
  }
  .img_two{
    width: 136px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/other/img10.png');
    margin-right:6px;
    background-repeat: no-repeat;
  }
  .img_three{
    width: 190px;
    height: 22px;
    background: url('~@/assets/image/variousproducts/other/img11.png');
    margin-bottom:7px;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .img_four{
    width: 241px;
    height: 52px;
    background: url('~@/assets/image/variousproducts/other/img12.png');
    background-repeat: no-repeat;
  }





</style>
